import { useRelativeDateCondition } from '../../../../filter/relative-date-condition/relative-date-condition.hook';
import {
  useActiveVizFieldSelector,
  useDiscoveryIdSelector,
} from '../../../../../common/redux/selectors/viz-selector.hook';
import { isEmpty, isString, map } from 'lodash';
import { TimePeriods } from '../../../../filter/relative-date-condition';
import { useEffect } from 'react';
import { TimestampSlicerTypes } from '../../../interfaces';
import { Viz } from '../../../../VizUtil';
import { relativeTimestampOperators } from '../../../../filter/FilterOperators';

export const toStrings = (operands: any[]) =>
  map(operands, (value: string | number | boolean) =>
    isString(value) ? value : JSON.stringify(value),
  ) as unknown as string[];

export const useSlicerOptionDateRange = ({
  scalarValue = 0,
  timePeriod,
  includeCurrentPartial,
  fieldName,
  type,
}: {
  scalarValue: number;
  timePeriod: keyof typeof TimePeriods;
  includeCurrentPartial: boolean;
  fieldName: string;
  type?: TimestampSlicerTypes;
}) => {
  const operands = toStrings([
    scalarValue,
    isEmpty(timePeriod) ? TimePeriods.DAYS.key : timePeriod,
    includeCurrentPartial,
  ]);

  const vizId = useDiscoveryIdSelector();
  const field = useActiveVizFieldSelector({
    discoveryId: vizId,
    name: fieldName,
  });

  const filter = Viz.filterFromTimestampType(field, type, operands);
  const { operator = relativeTimestampOperators.thisAndPast.key } =
    filter?.expression?.left ?? {};

  const {
    dateTimeFormat,
    datasetId,
    useFiscalCalendar,
    relativeDatesState,
    onIncludeFractionalPeriod,
    onPeriodOperatorChange,
    onOffsetChange,
    onOperatorChange,
  } = useRelativeDateCondition({ vizId, filter, field }, true);

  useEffect(() => {
    onIncludeFractionalPeriod(includeCurrentPartial);
    onPeriodOperatorChange(timePeriod);
    onOffsetChange(scalarValue);
    onOperatorChange(operator);
  }, [
    scalarValue,
    includeCurrentPartial,
    onIncludeFractionalPeriod,
    onOffsetChange,
    onOperatorChange,
    onPeriodOperatorChange,
    timePeriod,
    operator,
  ]);

  return {
    dateTimeFormat,
    datasetId,
    useFiscalCalendar,
    relativeDatesState,
  };
};
